module.exports = __webpack_public_path__ + "img/E8E8DE_B5B5A6_CCCCBC_C4C4BA-256px.cc470d60.png";